"use client"

import { Button } from '@/components/Button/Button';
import { formatPrice } from '@/utils/pricingUtils';
import styles from './CartQuantityPicker.module.scss';
import dayjs from 'dayjs';

type CartQuantityPickerProps = {
  ticketPrice: string,
  showTicketPrice: boolean,
  showTotalPrice: boolean,
  qty: number,
  setQty: {
    (qty: number): void;
  },
  loading: boolean,
  leftText: string,
  leftSubText: string,
  numDays?: string,
  year?: string,
  date: string | undefined,
}

export function CartQuantityPicker({ticketPrice, showTicketPrice, showTotalPrice, qty, setQty, loading, leftText, leftSubText, numDays, year, date }: CartQuantityPickerProps) {

  const ticketPriceDiv = showTicketPrice ? (
    <div>
      <p className={ styles.price }>&pound;{ ticketPrice }</p>
      { numDays ? <p className={ styles.sub }>{numDays} days</p> : null }
    </div>
  ) : null

  const totalPriceDiv = showTotalPrice ? (
    <div>
      <p className={ styles.price }>&pound;{ formatPrice(parseFloat(ticketPrice) * qty) }</p>
    </div>
  ) : null

  const formattedDate = dayjs(date).format("DD-MM-YYYY")

  return (
    <div className={ styles.container }>
      <div>
        <p className={ styles.title }>{ leftText }{year && ' - ' + year}</p>
        {date && <p>{formattedDate}</p>}
        <p className={ styles.sub }>{ leftSubText }</p>
      </div>
      { ticketPriceDiv }
      <div className={`${styles.qtyChangerContainer} ${loading ? styles.loading : ''}`}>
        <>
          <Button
            onClick={() => qty ? setQty(qty - 1) : null}
            className={`${styles.qtyChanger}
            ${qty === 0 ? styles.qtyChangerDisabled : ''}`}
          >
            <span className={styles.visuallyHidden}>Remove a ticket</span>
          </Button>
          <span className={ styles.qty }>{ qty }</span>
          <Button
            onClick={ () => setQty(qty + 1) }
            className={`${styles.qtyChanger} ${styles.qtyChangerAdd}`}
          >
            <span className={styles.visuallyHidden}>Add a ticket</span>
          </Button>
        </>
      </div>
      { totalPriceDiv }
    </div>
  )
}
